import { defineMessages } from 'react-intl';

export default defineMessages({
	projectsListLinkedLozengeLabel: {
		defaultMessage: 'Linked',
		description: 'Projects list linked lozenge label',
		id: 'projects.list.linked.lozenge.label',
	},
	projectsListUnlinkedLozengeLabel: {
		defaultMessage: 'Unlinked',
		description: 'Projects list unlinked lozenge label',
		id: 'projects.list.unlinked.lozenge.label',
	},
	projectsListLinkButtonText: {
		defaultMessage: 'Link',
		description: 'Projects list link button text',
		id: 'projects.list.link.button.text',
	},
	projectsListUnlinkButtonText: {
		defaultMessage: 'Unlink',
		description: 'Projects list unlink button text',
		id: 'projects.list.unlink.button.text',
	},
	noUnlinkedProjectsDescription: {
		defaultMessage: 'When you unlink projects, they’ll appear here.',
		description: 'Projects list empty state description',
		id: 'projects.list.empty.description',
	},
	noUnlinkedProjectsDescriptionGalaxia: {
		defaultMessage: 'When you unlink spaces, they’ll appear here.',
		description: 'Spaces list empty state description',
		id: 'projects.list.empty.description-galaxia',
	},
	noUnlinkedProjectsTitle: {
		defaultMessage: 'All your projects are linked to this help center',
		description: 'Projects list empty state title',
		id: 'projects.list.empty.title',
	},
	noUnlinkedProjectsTitleGalaxia: {
		defaultMessage: 'All your spaces are linked to this help center',
		description:
			'Empty state title shown in the spaces list when all spaces are linked to the help center',
		id: 'projects.list.empty.title-galaxia',
	},
	noLinkedProjectsDescription: {
		defaultMessage: 'When you link projects, they’ll appear here.',
		description: 'Projects list empty state description on linked tab',
		id: 'projects.list.empty.description.linked.tab',
	},
	noLinkedProjectsDescriptionGalaxia: {
		defaultMessage: 'When you link spaces, they’ll appear here.',
		description: 'Spaces list empty state description on linked tab',
		id: 'projects.list.empty.description.linked.tab-galaxia',
	},
	noLinkedProjectsTitle: {
		defaultMessage: 'All your projects have been unlinked from this help center',
		description: 'Projects list empty state title on linked tab',
		id: 'projects.list.empty.title.linked.tab',
	},
	noLinkedProjectsTitleGalaxia: {
		defaultMessage: 'All your spaces have been unlinked from this help center',
		description: 'Spaces list empty state title on linked tab',
		id: 'projects.list.empty.title.linked.tab-galaxia',
	},
	projectsListEmptySearchTitle: {
		defaultMessage: 'No projects found matching your search',
		description: 'Projects list empty search title',
		id: 'projects.list.empty.search.title',
	},
	projectsListEmptySearchTitleGalaxia: {
		defaultMessage: 'No spaces found matching your search',
		description: 'Spaces list empty search title',
		id: 'projects.list.empty.search.title-galaxia',
	},
	projectsListEmptySearchDescription: {
		defaultMessage: 'Try using specific project names or terms',
		description: 'Projects list empty search description',
		id: 'projects.list.empty.search.description',
	},
	projectsListEmptySearchDescriptionGalaxia: {
		defaultMessage: 'Try using specific space names or terms',
		description: 'Spaces list empty search description',
		id: 'projects.list.empty.search.description-galaxia',
	},
	selectAllProjectsCheckboxLabel: {
		defaultMessage: 'Select all projects',
		description: 'Checkbox label for selecting all projects',
		id: 'projects.list.select-all.projects.checkbox.label',
	},
	selectAllProjectsCheckboxLabelGalaxia: {
		defaultMessage: 'Select all spaces',
		description: 'Checkbox label for selecting all spaces',
		id: 'projects.list.select-all.projects.checkbox.label-galaxia',
	},
	selectProjectCheckboxLabel: {
		defaultMessage: 'Select project',
		description: 'Checkbox label for selecting a single project',
		id: 'projects.list.select.project.checkbox.label',
	},
	selectProjectCheckboxLabelGalaxia: {
		defaultMessage: 'Select space',
		description: 'Checkbox label for selecting a single space',
		id: 'projects.list.select.project.checkbox.label-galaxia',
	},
	columnHeaderSpace: {
		defaultMessage: 'Space',
		description: 'Spaces list column header space',
		id: 'spaces.list.column.header.space-galaxia',
	},
	columnHeaderLead: {
		defaultMessage: 'Lead',
		description: 'Spaces list column header lead',
		id: 'spaces.list.column.header.lead',
	},
	columnHeaderStatus: {
		defaultMessage: 'Status',
		description: 'Spaces list column header status',
		id: 'spaces.list.column.header.status',
	},
	columnHeaderActions: {
		defaultMessage: 'Actions',
		description: 'Spaces list column header actions',
		id: 'spaces.list.column.header.actions',
	},
});
